import AppUtils from '@/utils/AppUtils'
const VDebugStyleManager = {
  styleId: 'v-debug-style',
  create() {
    if (!document.getElementById(this.styleId)) {
      const style = document.createElement('style');
      style.setAttribute('type', 'text/css');
      style.id = this.styleId;
      style.textContent = `
        [v-debug] {
          display: block !important;
        }
        tr[v-debug] {
          display: table-row !important;
        }
      `;
      document.head.appendChild(style);
    }
  },
  remove() {
    const style = document.getElementById(this.styleId);
    if (style) {
      style.remove();
    }
  },
};

export default {
  data () {
    return {
      baseDebug: import.meta.env.VITE_DEBUG,
      hideDebugElement: !AppUtils.isDebugMode()
    }
  },
  computed: {
    // ! deprecated
    localDebug: {
      get () {
        return !this.mockProduction
      },
      set (val) {
        this.mockProduction = !val
      }
    },
    mockProduction: {
      get () {
        return !AppUtils.isDebugMode()
      },
      set (val) {
        localStorage.setItem('mockProduction', val ? 1 : 0)
      }
    }
  },
  watch:{
    hideDebugElement: {
      immediate: true,
      handler(val) {
        if (!import.meta.env.VITE_DEBUG) return // failsafe check
        if (val) {
          VDebugStyleManager.remove();
        } else {
          VDebugStyleManager.create();
        }
      }
    }
  },
  methods: {
    // ! deprecated
    toggleDebug () {
      this.localDebug = !this.localDebug
      alert('(Reload window) MockProduction: ' + !this.localDebug)
      window.location.reload()
    },
    toggleMockProduction () {
      this.mockProduction = !this.mockProduction
      alert('(Reload window) MockProduction: ' + this.mockProduction)
      window.location.reload()
    },
    toggleHideDebugElement (value) {
      this.hideDebugElement = value
    }
  }
}
